export { default } from "./Page";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-admin/Page/index.js